/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
import {
  Heading,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
} from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import moment from "moment";
import { useEffect, useState } from "react";
import { dateFormat, dateTimeFormat } from "../../utils/constants";

export function ServicePointDetails({ servicePoint }) {
  // console.log("servicePoint", servicePoint);
  return (
    <form>
      <FormControl>
        <FormLabel>Customer</FormLabel>
        <Input readOnly value={servicePoint.customer} />
      </FormControl>
      <FormControl>
        <FormLabel>Cash Center</FormLabel>
        <Input readOnly value={servicePoint.cashCenter} />
      </FormControl>
      <FormControl>
        <FormLabel>Location ID</FormLabel>
        <Input readOnly value={servicePoint.locationId} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Name</FormLabel>
        <Input readOnly value={servicePoint.locationName} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Code</FormLabel>
        <Input readOnly value={servicePoint.locationCode} />
      </FormControl>
      <FormControl>
        <FormLabel>Category</FormLabel>
        <Input readOnly value={servicePoint.category} />
      </FormControl>
      <FormControl>
        <FormLabel>Route</FormLabel>
        <Input readOnly value={servicePoint.routeNo} />
      </FormControl>
      <FormControl>
        <FormLabel>Location Type</FormLabel>
        <Input readOnly value={servicePoint.locationType} />
      </FormControl>
      <FormControl>
        <FormLabel>Status</FormLabel>
        <Input readOnly value={servicePoint.status} />
      </FormControl>
      <FormControl>
        <FormLabel>Site Type</FormLabel>
        <Input readOnly value={servicePoint.siteType} />
      </FormControl>
      <FormControl>
        <FormLabel>Barcode</FormLabel>
        <Input readOnly value={servicePoint.barcode} />
      </FormControl>
      <FormControl>
        <FormLabel>Site Limit</FormLabel>
        <Input readOnly value={servicePoint.siteLimit} />
      </FormControl>
      <FormControl>
        <FormLabel>Distance From Base</FormLabel>
        <Input readOnly value={servicePoint.distanceFromBase} />
      </FormControl>
      <FormControl>
        <FormLabel>Co-Located Group No</FormLabel>
        <Input readOnly value={servicePoint.coLocatedGroupNo || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Country</FormLabel>
        <Input readOnly value={servicePoint.country} />
      </FormControl>
      <FormControl>
        <FormLabel>State</FormLabel>
        <Input readOnly value={servicePoint.state} />
      </FormControl>
      <FormControl>
        <FormLabel>City</FormLabel>
        <Input readOnly value={servicePoint.city} />
      </FormControl>
      <FormControl>
        <FormLabel>Emirate</FormLabel>
        <Input readOnly value={servicePoint.emirate} />
      </FormControl>
      <FormControl>
        <FormLabel>Address</FormLabel>
        <Input readOnly value={servicePoint.address} />
      </FormControl>
      <FormControl>
        <FormLabel>Longitude</FormLabel>
        <Input readOnly value={servicePoint.longitude} />
      </FormControl>
      <FormControl>
        <FormLabel>Latitude</FormLabel>
        <Input readOnly value={servicePoint.latitude} />
      </FormControl>
      <FormControl>
        <FormLabel>First Service Date</FormLabel>
        <Input
          readOnly
          value={
            servicePoint.firstServiceDate
              ? moment(servicePoint.firstServiceDate).format(dateFormat)
              : ""
          }
        />
      </FormControl>
      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Input readOnly value={servicePoint.serviceDays?.join(",") || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Allowed Days</FormLabel>
        <Input readOnly value={servicePoint.allowedDays?.join(",") || ""} />
      </FormControl>
      <FormControl>
        <FormLabel>Alarm Details</FormLabel>
        <Input readOnly value={servicePoint.alarmDetails} />
      </FormControl>
      <FormControl>
        <FormLabel>Fixing Side</FormLabel>
        <Input readOnly value={servicePoint.fixingSide} />
      </FormControl>
      <FormControl>
        <FormLabel> Loading Side</FormLabel>
        <Input readOnly value={servicePoint.loadingSide} />
      </FormControl>
      <FormControl>
        <FormLabel> Machine Type</FormLabel>
        <Input readOnly value={servicePoint.machineType} />
      </FormControl>
      <FormControl>
        <FormLabel> Maker</FormLabel>
        <Input readOnly value={servicePoint.maker} />
      </FormControl>
      <FormControl>
        <FormLabel> Model</FormLabel>
        <Input readOnly value={servicePoint.model} />
      </FormControl>
      <FormControl>
        <FormLabel> Lock Serial No</FormLabel>
        <Input readOnly value={servicePoint.lockSerialNo} />
      </FormControl>
      <FormControl>
        <FormLabel> Machine Serial No</FormLabel>
        <Input readOnly value={servicePoint.machineSerialNo} />
      </FormControl>
      <FormControl>
        <FormLabel>Maximum Cassettes</FormLabel>
        <Input readOnly value={servicePoint.maximumCassettes} />
      </FormControl>
      <FormControl>
        <FormLabel>Lock Installation Date</FormLabel>
        <Input
          readOnly
          value={
            servicePoint.lockInstallationDate
              ? moment(servicePoint.lockInstallationDate).format(dateFormat)
              : ""
          }
        />
      </FormControl>
      <div style={{ width: "100%" }} />
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.requiresCashierCount}>
          <FormLabel style={{ margin: 0 }}>Requires Cashier Count</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.requiresEVhr}>
          <FormLabel style={{ margin: 0 }}>Requires EVhr</FormLabel>
        </Checkbox>
      </FormControl>
      <FormControl style={{ display: "flex", flexDirection: "row" }}>
        <Checkbox isChecked={servicePoint.hasSecurityAlarm}>
          <FormLabel style={{ margin: 0 }}>Has Security Alarm</FormLabel>
        </Checkbox>
      </FormControl>
      {servicePoint.locationId ? (
        <>
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Site SLAs
          </Heading>
          <SiteSLAs SLAList={servicePoint.siteSLAs} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Operational Windows
          </Heading>
          <OperationalWindow
            operationalWindows={servicePoint.operationalWindows}
          />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Service Windows
          </Heading>
          <OperationalWindow operationalWindows={servicePoint.serviceWindows} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Cassettes
          </Heading>
          <Cassettes cassettes={servicePoint.cassettes} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Denominations
          </Heading>
          <Denominations denominations={servicePoint.denominations} />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Replenishment Models
          </Heading>
          <ReplenishmentModels
            replenishmentModels={servicePoint.replenishmentModels}
          />
          <Heading
            style={{ fontSize: "16px", margin: "25px 0", width: "100%" }}
          >
            Site Representatives
          </Heading>
          <Representatives representatives={servicePoint.siteRepresentatives} />
        </>
      ) : (
        <></>
      )}
    </form>
  );
}

function SiteSLAs({ SLAList }) {
  return (
    <Grid data={SLAList}>
      <GridColumn title="Service Type" field="serviceType" />
      <GridColumn title="Activity Type" field="activityType" />
      <GridColumn title="Response Time(mins)" field="responseTime" />
      <GridColumn title="Attended Time(mins)" field="attendedTime" />
      <GridColumn title="Resolution Time(mins)" field="resolutionTime" />
    </Grid>
  );
}

function OperationalWindow({ operationalWindows }) {
  return (
    <Grid data={operationalWindows}>
      <GridColumn
        title="Start Date Time"
        cell={({ dataItem }) => (
          <td>{moment(dataItem.startDateTime).format(dateTimeFormat)}</td>
        )}
      />
      <GridColumn
        title="End Date Time"
        cell={({ dataItem }) => (
          <td>{moment(dataItem.endDateTime).format(dateTimeFormat)}</td>
        )}
      />
      <GridColumn
        title="Cut Off Time"
        cell={({ dataItem }) => (
          <td>{moment(dataItem.cutOffTime).format(dateTimeFormat)}</td>
        )}
      />
    </Grid>
  );
}

function Cassettes({ cassettes }) {
  return (
    <Grid data={cassettes}>
      <GridColumn title="Description" field="description" />
      <GridColumn title="Denomination" field="denomination" />
      <GridColumn title="Cassette Type" field="cassetteType" />
      <GridColumn title="Maker" field="maker" />
      <GridColumn title="Limit" field="limit" />
      <GridColumn
        title="Dual Scanning"
        cell={({ dataItem }) => (
          <td>
            <Checkbox isChecked={dataItem.dualScanning} />
          </td>
        )}
      />
    </Grid>
  );
}
function Denominations({ denominations }) {
  return (
    <Grid data={denominations}>
      <GridColumn title="Currency" field="currency" />
      <GridColumn title="multiple" field="multiple" />
      <GridColumn title="Shape" field="shape" />
      <GridColumn title="Version" field="version" />
    </Grid>
  );
}

function ReplenishmentModels({ replenishmentModels }) {
  const [models, setModels] = useState([]);
  useEffect(() => {
    setModels(replenishmentModels.map((elm) => ({ ...elm, expanded: false })));
  }, []);
  const expandChange = ({ dataIndex }) => {
    const _models = [...models];
    _models[dataIndex].expanded = !_models[dataIndex].expanded;
    setModels(_models);
  };

  function DetailComponent({ dataItem }) {
    return (
      <>
        <Heading
          style={{
            width: "100%",
            fontSize: "16px",
            padding: "10px 0px",
            margin: 0,
          }}
        >
          Denominations
        </Heading>

        <Grid data={dataItem.denominations}>
          <GridColumn field="denomination" title="Denomination" />
          <GridColumn field="noOfCassettes" title="Cassettes" />
          <GridColumn field="noOfNotes" title="Notes" />
        </Grid>
      </>
    );
  }
  return (
    <Grid
      data={models}
      detail={DetailComponent}
      expandField="expanded"
      onExpandChange={expandChange}
    >
      <GridColumn title="Code" field="code" />
    </Grid>
  );
}

function Representatives({ representatives }) {
  return (
    <Grid data={representatives}>
      <GridColumn title="Name" field="name" />
      <GridColumn title="Employee ID" field="employeeId" />
      <GridColumn title="Email" field="email" />
      <GridColumn title="Mobile No" field="mobileNo" />
    </Grid>
  );
}
